import { notify } from '@p2p/components';
import { useEffect, useState } from 'react';

import { usePaymentData } from '..';
import styles from './UseTimeEndNotification.module.scss';

const TWO_MINUTES = 2 * 60;

type UseTimeEndNotificationOptions = {
  // P2P-2880: на proof_page уведомление нужно, только пока плательщик не нажал
  // «Деньги отправлены». По умолчанию включено (msp_page — как раньше).
  enabled?: boolean;
};

export const useTimeEndNotification = ({ enabled = true }: UseTimeEndNotificationOptions = {}) => {
  const { order, pageSettings } = usePaymentData();
  const [isShownNotification, setIsShownNotification] = useState(false);

  useEffect(() => {
    if (
      order?.time_left &&
      order?.time_left < TWO_MINUTES &&
      !isShownNotification &&
      pageSettings.notification &&
      enabled
    ) {
      notify({
        title: 'Время для оплаты почти истекло',
        content: 'Осталось 2 минуты. Пожалуйста, обратите внимание.',
        timer: 5000,
        className: styles.wrapper,
      });
      setIsShownNotification(true);
    }
  }, [order?.time_left, isShownNotification, pageSettings.notification, enabled]);
};
